import { render } from "./PlotManager.vue?vue&type=template&id=21527b4e&scoped=true"
import script from "./PlotManager.vue?vue&type=script&lang=js"
export * from "./PlotManager.vue?vue&type=script&lang=js"

import "./PlotManager.vue?vue&type=style&index=0&id=21527b4e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21527b4e"]])

export default __exports__